import { LazyLoad } from 'app/utils';

export const RankingListPage = LazyLoad(
  () => import('./index'),
  (module) => module.RankingListPage,
);
